<template>
  <span>
    <v-text-field
      class="rounded-lg"
      v-model="localValue"
      @input="change"
      dir="ltr"
      :label="label"
      :placeholder="placeholder"
      :disabled="disabled"
      clearable
      style="min-width: 140px"
      v-bind="$attrs"
      @click:clear="isDirty = true"
      :id="id"
    >
      <template #append>
        <v-icon
          :disabled="disabled"
          class="mt-1"
          @click="$refs.datepicker.visible = true"
          @contextmenu.prevent="setToday"
        >
          fa-calendar-day
        </v-icon>
      </template>
    </v-text-field>
    <vue-persian-datetime-picker
      v-model="localValue"
      @input="change"
      ref="datepicker"
      :element="id"
      :editable="true"
      :type="type"
      :format="type == 'date' ? 'jYYYY/jMM/jDD' : 'jYYYY/jMM/jDD HH:mm'"
    />
  </span>
</template>

<script>
import IMask from "imask";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "Date",
  props: {
    value: {},
    default: {},
    disabled: {},
    placeholder: {},
    label: {},
    type: {
      default: "date",
    },
  },
  components: { VuePersianDatetimePicker },
  data() {
    return {
      localValue: null,
      mask: null,
      isDirty: false,
      id: "date" + (Math.random() * 100000).toFixed(0),
    };
  },
  watch: {
    value() {
      this.localValue = this.getValue();

      if (this.localValue == undefined && this.default && !this.isDirty) {
        this.setToday();
      }
    },
  },
  created() {
    if (this.type == "date") {
      this.mask = IMask.createMask({
        mask: "YYYY/MM/DD",
        lazy: true,
        blocks: {
          YYYY: {
            mask: "0000",
          },
          MM: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
          },
          DD: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
          },
        },
      });
    } else {
      this.mask = IMask.createMask({
        mask: "YYYY/MM/DD HH:mm",
        lazy: true,
        blocks: {
          YYYY: {
            mask: "0000",
          },
          MM: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
          },
          DD: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
          },
          HH: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23,
          },
          mm: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
          },
        },
      });
    }
  },
  mounted() {
    if (this.default && !this.getValue() && !this.isDirty) {
      this.setToday();
    } else {
      this.localValue = this.getValue();
    }

    this.EventBus.$on("clearForm", () => {
      if (this.default) {
        this.setToday();
      }
    });
  },
  methods: {
    getValue() {
      let value = "";
      if (this.value) {
        if (this.type == "date") {
          value = this.toJDate(this.value);
        } else {
          value = this.toJDatetime(this.value);
        }
      } else {
        value = this.value;
      }
      return value;
    },
    change() {
      this.isDirty = true;
      if (this.localValue != this.getValue()) {
        this.mask.resolve(String(this.localValue));
        this.$nextTick(() => {
          let maskedValue = this.mask.value;
          if (maskedValue == "") maskedValue = null;
          this.localValue = maskedValue;
          if (this.type == "date") {
            this.$emit("input", this.toGDate(maskedValue));
          } else {
            this.$emit("input", this.toGDatetime(maskedValue));
          }
        });
      }
    },
    setToday() {
      // this.isDirty = true;
      // this.localValue = this.serverNow.format("jYYYY/jMM/jDD");
      // this.localValue = this.d
      // this.change();
      // this.$emit("input", this.toGDate(this.mask.value));
    },
  },
};
</script>

<style lang="css">
input {
  direction: ltr;
}
</style>
